import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { isVirusItem } from 'reactApp/modules/file/utils';
import { PublicItem } from 'reactApp/modules/public/public.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { StockItem } from 'reactApp/modules/stock/stock.type';
import { getStorageItemById } from 'reactApp/modules/storage/storage.selectors';
import { RootState } from 'reactApp/store';
import { getThumbUrl } from 'reactApp/ui/Mobile/Datalist/DatalistPic/DatalistPic.helpers';
import { ItemInfo } from 'reactApp/ui/Mobile/OptionsModal/ItemInfo/ItemInfo';

interface IItemInfoContainerProps {
    id: string;
}

export const ItemInfoContainer = memo<IItemInfoContainerProps>(function ItemInfoContainer({ id }) {
    const storage = useSelector(getCurrentStorage);
    const item = useSelector((state: RootState) => getStorageItemById(state, storage, id)) as PublicItem | StockItem;

    const isFolder = item.isFolder;
    const ext = isFolder ? undefined : item?.ext;
    const name = isFolder ? item?.name : item?.nameWithoutExt;
    const isVirus = isVirusItem(item);

    const thumbUrl = getThumbUrl({
        viewMode: EViewMode.list,
        item,
        isVirus,
    });

    return (
        <ItemInfo
            thumbUrl={thumbUrl}
            ext={ext}
            isFolder
            isVirus={isVirus}
            kind={item.kind}
            name={name}
            size={'size' in item ? item.size : undefined}
            storage={storage}
        />
    );
});
